import React, { useEffect, useState } from "react";
import { Avatar, Box, Divider, Grid, ListItem, ListItemAvatar, ListItemText, Typography } from "@mui/material"
import { api } from "../../config/apiCaller.config";
import noImage from '../../assets/img/no_image.jpg';

import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { type } from "os";

const WelcomePage: React.FC = () => {
    const [page, setPage] = useState(1);
    const [limit] = useState(3);

    const [redemptionItems, setRedemptionItems] = useState([]);
    const [spentExtractItems, setSpentExtractItems] = useState([]);
    const [earnedExtractItems, setEarnedExtractItems] = useState([]);

    const loadRedemptions = async () => {
        try {
            const response = await api.get(`/redemptions/me?page=${page}&limit=${limit}`);
            
            if (response.status === 200) {
                setRedemptionItems(response.data.data);
            }
        } catch (error: any) {
            setRedemptionItems([]);
        }
            
    }

    const loadExtract = async (type: string) => {
        try {
            const response = await api.get(`/wallet/transactions/customer/me?page=${page}&limit=${limit}&type=${type}`);
            
            if (response.status === 200) {
                if (type === 'spent') {
                    setSpentExtractItems(response.data.data);
                } else {
                    setEarnedExtractItems(response.data.data);
                }
            }
        } catch (error: any) {
            if (type === 'spent') {
                setSpentExtractItems([]);
            } else {
                setEarnedExtractItems([]);
            }
        }  
    }

    const formatStatus = (status: string) => {
        switch (status) {
            case 'pending':
                return 'Pendente';
            case 'completed':
                return 'Concluido';
            case 'cancelled':
                return 'Cancelado';
            default:
                return status;
        }
    }

    const checkStatusColor = (status: string) => {
        switch (status) {
            case 'pending':
                return 'orange';
            case 'completed':
                return 'green';
            case 'cancelled':
                return 'red';
            default:
                return 'black';
        }
    }

    const checkDescription = (description: string) => {
        switch (description) {
            case 'Points expired':
                return 'Pontos expirados';
            default:
                return description;
        }
    }

    useEffect(() => {
        loadRedemptions();
        loadExtract('spent');
        loadExtract('earned');

    }
    , [page]);

    return (
        <Box height="100vh" bgcolor="#FFFFFF">
            <Typography variant='h4' color='textPrimary'>Bem-vindo</Typography>
            <Typography variant="subtitle1" color="textSecondary">Neste portal você pode acompanhar seus pontos e realizar resgates</Typography>

            <Grid container spacing={2}>
                
                {/* Meus últimos créditos */}
                <Grid item xs={12} sm={6}>
                    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" bgcolor="#F5F5F5" borderRadius="10px" p={2} mt={2}>
                        <Typography variant="h6" color="textPrimary">Meus últimos créditos</Typography>
                        {earnedExtractItems?.length ? earnedExtractItems.map((item: any) => (
                                <React.Fragment key={item._id}>
                                    <ListItem alignItems="flex-start">
                                        <ListItemAvatar>
                                            
                                                {item.type === 'spent' ? 
                                                    <Avatar style={{ backgroundColor: 'red' }}>
                                                        <MoneyOffIcon /> 
                                                    </Avatar>
                                                    : 
                                                    <Avatar style={{ backgroundColor: 'green' }}>
                                                        <AttachMoneyIcon />
                                                    </Avatar>
                                                }
                                            
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={<b>{checkDescription(item.description)}</b>}                                    
                                            secondary={
                                                <React.Fragment>
                                                <Typography
                                                    component="span"
                                                    variant="body2"
                                                    sx={{ color: 'text.primary', display: 'inline' }}
                                                >
                                                    <b>Data:</b> {new Date(item.createdAt).toLocaleDateString()}
                                                </Typography>
                                                <b> Pontos:</b> {` ${item.points}`}
                                                </React.Fragment>
                                            }
                                        />
                                    </ListItem>
                                </React.Fragment>
                            )) : <Typography variant="h6" color="textSecondary" textAlign={'center'}>Nenhuma movimentação encontrada</Typography>}
                    </Box>
                </Grid>
                    

                {/* Meus últimos débitos */}
                <Grid item xs={12} sm={6}>
                    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" bgcolor="#F5F5F5" borderRadius="10px" p={2} mt={2}>
                        <Typography variant="h6" color="textPrimary">Meus últimos débitos</Typography>
                        {spentExtractItems?.length ? spentExtractItems.map((item: any) => (
                                <React.Fragment key={item._id}>
                                    <ListItem alignItems="flex-start">
                                        <ListItemAvatar>
                                            
                                                {item.type === 'spent' ? 
                                                    <Avatar style={{ backgroundColor: 'red' }}>
                                                        <MoneyOffIcon /> 
                                                    </Avatar>
                                                    : 
                                                    <Avatar style={{ backgroundColor: 'green' }}>
                                                        <AttachMoneyIcon />
                                                    </Avatar>
                                                }
                                            
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={<b>{checkDescription(item.description)}</b>}                                    
                                            secondary={
                                                <React.Fragment>
                                                <Typography
                                                    component="span"
                                                    variant="body2"
                                                    sx={{ color: 'text.primary', display: 'inline' }}
                                                >
                                                    <b>Data:</b> {new Date(item.createdAt).toLocaleDateString()}
                                                </Typography>
                                                <b> Pontos:</b> {` ${item.points}`}
                                                </React.Fragment>
                                            }
                                        />
                                    </ListItem>
                                </React.Fragment>
                            )) : <Typography variant="h6" color="textSecondary" textAlign={'center'}>Nenhuma movimentação encontrada</Typography>}
                    </Box>
                </Grid>
            </Grid>

            {/* Meus últimos resgates */}
            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" bgcolor="#F5F5F5" borderRadius="10px" p={2} mt={2}>
                <Typography variant="h6" color="textPrimary">Meus últimos resgates</Typography>
                {redemptionItems?.length? redemptionItems.map((item: any, index) =>
                    <React.Fragment key={item._id}>
                        <ListItem alignItems="flex-start">
                            <ListItemAvatar>
                                {item.items[0]?.medias?.length ? 
                                    <Avatar  
                                        alt={item.items[0].name}
                                        src={`http://${process.env.REACT_APP_API_URL}/rewards/image/${item.items[0].medias[0]}`}
                                    />
                                    :
                                    <Avatar 
                                        alt="Item Image" 
                                        src={noImage}
                                    />
                                }
                            </ListItemAvatar>
                            <ListItemText
                                primary={item.items[0]?.name}
                                secondary={
                                    <React.Fragment>
                                    <Typography
                                        component="span"
                                        variant="body2"
                                        sx={{ color: 'text.primary', display: 'inline' }}
                                    >
                                        <b>Data do resgate</b>: {new Date(item.redeemedAt).toLocaleDateString() } <ListItemText style={{ color: checkStatusColor(item.status) }} primary={formatStatus(item.status)} />
                                    </Typography>
                                    <b> Pontos: </b> {item.points}
                                    </React.Fragment>
                                }
                            />
                            </ListItem>
                    </React.Fragment>)
                    : 
                    <Typography variant="h6" color="textSecondary" textAlign={'center'}>Nenhum resgate encontrado</Typography>
                }
            </Box>

            
        </Box>

    )
}

export { WelcomePage }